<template>
  <a-layout class="container">
    <!-- 左侧区域 -->
    <hina-base-slider :currentMenuKey="curMenuKey" :currentOpenKey="curOpenKey" />
    <!-- 主体区域 -->
    <a-layout>
      <!-- 头部 -->
      <hina-user-info :user="objUserInfo" />

      <a-layout-content>
        <!-- 位置 -->
        <hina-bread-crumb :link="arrBreadLink" />

        <div class="wrapper">
          <div class="wrap">
            <!-- 头部 -->
            <div class="hd">
              <div class="filter">
                <!-- <div class="title">关联实体卡列表</div> -->
                <div class="title">实体卡列表</div>
                <div class="query">
                  <div class="query-item"></div>
                  <div class="query-item">
                    <!-- <a-input v-model="queryParams" @keyup.enter="loadStaffList" type="text" /> -->
                  </div>
                  <div class="query-item">
                    <!-- <a-button @click="loadStaffList" type="primary">查询</a-button> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- 搜索栏  @submit="handleSubmit"-->
            <div class="search-box">
              <div class="search-item">
                <div class="search-item-title">分类ID</div>
                <div class="search-item-cont">
                  <a-input v-model="cardParams.id" placeholder="请输入分类ID" style="width: 100%;" />
                </div>
              </div>
              <div class="search-item">
                <div class="search-item-title">批次</div>
                <div class="search-item-cont">
                  <a-input v-model="cardParams.batch" placeholder="请输入批次" style="width: 100%;" />
                </div>
              </div>
              <div class="search-item">
                <div class="search-item-title">到期时间</div>
                <div class="search-item-cont">
                  <a-date-picker @change="onChange" placeholder="请选择到期时间" style="width: 100%;" />
                </div>
              </div>
              <div class="search-item">
                <div class="search-item-title">开始卡号</div>
                <div class="search-item-cont">
                  <a-input v-model="cardParams.startCardId" placeholder="请输入开始卡号" style="width: 100%;" />
                </div>
              </div>
              <div class="search-item">
                <div class="search-item-title">结束卡号</div>
                <div class="search-item-cont">
                  <a-input v-model="cardParams.endCardId" placeholder="请输入结束卡号" style="width: 100%;" />
                </div>
              </div>
              <div class="search-item">
                <div class="search-item-title"></div>
                <div class="search-item-cont">
                  <a-button type="primary" @click="searchBtn">搜索</a-button>
                </div>
              </div>
            </div>
            <!-- 表单 -->
            <div class="trans-table">
              <a-table
                :columns="columns"
                :data-source="data"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
                row-key="id"
              >
                <template slot="useFlagSlot" slot-scope="row">
                  <div>
                    <a-tag v-if="row" color="green">已使用</a-tag>
                    <a-tag v-if="!row" color="red">未使用</a-tag>
                  </div>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import HinaBaseSlider from 'components/HinaBaseSlider/HinaBaseSlider'
import HinaUserInfo from 'components/HinaUserInfo/HinaUserInfo'
import HinaBreadCrumb from 'components/HinaBreadCrumb/HinaBreadCrumb'
import utils from 'assets/js/util'
import vueQr from 'vue-qr'
import locale from 'ant-design-vue/lib/date-picker/locale/zh_CN'

export default {
  name: 'Profile',
  components: {
    HinaBaseSlider,
    HinaUserInfo,
    HinaBreadCrumb,
    vueQr
  },
  data() {
    return {
      locale,
      objUserInfo: {},
      curMenuKey: ['cardList'],
      curOpenKey: ['sub5'],
      // curOpenKey: ['sub6'],
      arrBreadLink: [],
      color: 'error',
      pagination: {},
      loading: false,
      queryParams: '',
      data: [],
      columns: [
        // {
        //     title: '用户ID',
        //     dataIndex: 'userId',
        //     width: 200
        // },
        {
          title: '用户名称',
          dataIndex: 'name',
          width: 200
        },
        {
          title: '电话号码',
          dataIndex: 'phone'
        },
        {
          title: '卡号',
          dataIndex: 'cardId'
        },
        {
          title: '批次',
          dataIndex: 'batch'
        },
        {
          title: '兑换码',
          dataIndex: 'cardVoucher'
        },
        {
          title: '使用状态',
          dataIndex: 'useFlag',
          scopedSlots: { customRender: 'useFlagSlot' }
        },
        {
          title: '使用时间',
          dataIndex: 'useDate'
        },
        {
          title: '过期时间',
          dataIndex: 'expirationTime'
        },
        {
          title: '实体卡分类ID',
          dataIndex: 'physicalCardCategoryId'
        }
      ],
      cardParams: {
        pageSize: '10',
        pageNumber: '1',
        id: '', // 卡分类id
        batch: '', // 批次
        expirationTime: '', // 到期时间
        startCardId: '', // 开始卡号
        endCardId: '', // 结束卡号
        enterpriseInformationId: '' //企业卡号
      }, // 获取实体卡列表params
      pagination: {
        pageSize: 10,
        total: 0,
        current: 1
      }
    }
  },
  computed: {},
  mounted: function() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.cardParams.enterpriseInformationId = userInfo.id
    this.objUserInfo = {
      id: userInfo.id,
      name: userInfo.enterpriseFullName,
      adCode: userInfo.adCode
    }
    // this.arrBreadLink.push({ name: '实体卡管理', link: '/cardList' })
    // this.arrBreadLink.push({ name: '优惠码管理', link: '/cardList' })

    // this.arrBreadLink.push({ name: '会员卡管理', link: '/cardList' })
    this.arrBreadLink.push({ name: '渠道分销管理', link: '/cardList' })
    this.loadStaffList()
  },
  methods: {
    // 搜索按钮
    searchBtn() {
      ;(this.cardParams.pageNumber = '1'), this.loadStaffList()
    },
    // 时间选择器
    onChange(e) {
      if (e) {
        let crtDate = new Date(e._d).getTime()
        this.cardParams.expirationTime = utils.tampToDate(crtDate, 'Y-M-D')
      } else {
        this.cardParams.expirationTime = ''
      }
    },

    //查询实体卡列表
    loadStaffList() {
      // this.loading = true
      //查询对象
      this.data = []
      this.$get('/physical/card/listAll', this.cardParams).then(res => {
        if (res.success) {
          this.data = res.result.records
          this.pagination = {
            current: res.result.current,
            pageSize: res.result.size,
            total: res.result.total
          }
          this.loading = false
        }
      })
    },

    // 分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.cardParams.pageNumber = pagination.current
      this.loading = true
      this.loadStaffList()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .wrap {
    margin: 20px 0 0;
    padding: 0 24px;
    background: #fff;
    min-height: 240px;

    .hd {
      height: 72px;
      line-height: 72px;
      color: #333;
      font-weight: 600;
      font-size: 18px;
      position: relative;
      margin-bottom: 30px;

      &::after {
        position: absolute;
        content: '';
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        left: 0;
        right: 0;
        bottom: 0;
      }

      .filter {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .query {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .query-item {
            padding: 0 0 0 5px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    .search-box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      border-bottom: 1px solid #e2e2e2;
      margin-bottom: 20px;
      .search-item {
        width: 400px;
        height: 50px;
        display: flex;
        margin-bottom: 20px;
        .search-item-title {
          width: 100px;
          font-weight: 600;
          margin-right: 10px;
          text-align: right;
          line-height: 50px;
        }
        .search-item-cont {
          width: 300px;
          /deep/.ant-calendar-picker-input {
            padding-left: 10px;
          }
        }
      }
    }

    .trans-table {
      padding: 0 0 5px;
    }
  }

  .wrap:first-of-type {
    margin: 0;
  }
}

.frm-staff {
  padding: 20px 50px;
  text-align: center;

  .frm-line {
    min-height: 72px;
    padding: 12px 0;
    box-sizing: border-box;

    .lab {
      font-size: 16px;
      line-height: 48px;
      text-align: right;
      position: relative;

      &::after {
        position: relative;
        content: '：';
      }
    }

    .required {
      &::before {
        position: relative;
        content: '*';
        color: red;
        padding: 0 5px 0 0;
      }
    }

    .txt {
      line-height: 48px;
      font-size: 16px;
    }
  }
}
</style>
